export default {
    props: [
        'device_id',
        'device_alias'
    ],
    data() {
        return {
            status: {},
            onCtrl: {
                power: null
            },
            op_mode: '',
            humidity: 0,
            isLoading: false,
            isActive: false,
            polling: null,
            refreshTimer: null,
            errorCode: null,
            isOverflow: false,
            isDescOverflow: false
        }
    },
    mounted() {
        this.isLoading = true;
        this.getStatus();
        this.isOverflow = this.$refs.title.scrollWidth > this.$refs.title.offsetWidth;
        this.isDescOverflow = this.$refs.desc.scrollWidth > this.$refs.desc.offsetWidth;
    },
    methods: {
        load_component() {
            if (!['DISCONNECTED', 'ERROR'].includes(this.op_mode)) {
                this.$emit('selectDevice', 'DEVICE_DEHUMIDIFIER', this.device_id);
            }
        },
        pollData() {
            clearInterval(this.polling);
            this.polling = setInterval(async () => {
                for (let item of $simple_obj) {
                    if (!this.isAppIdle && item.deviceId === this.device_id) {
                        this.status = await item.getState(false);
                    }
                }
            }, process.env.VUE_APP_POLLING_DURATION);
        },
        async getStatus(mode) {
            for (let item of $simple_obj) {
                if (item.deviceId === this.device_id) {
                    if (item.platform === 'thinq10') {
                        this.pollData()
                    }
                    if (mode === false && item.platform === 'thinq10') {
                        clearTimeout(this.refreshTimer);
                        this.refreshTimer = setTimeout(async () => {
                            this.status = await item.getState(mode);
                        }, process.env.VUE_APP_REFRESH_DURATION)
                    } else {
                        this.status = await item.getState(true);
                    }
                    if (!this.status) {
                        this.op_mode = 'DISCONNECTED'
                        this.isLoading = false;
                    }
                }
            }
        },
        op_status() {
            for (let key in this.onCtrl) {
                this.onCtrl[key] = null;
            }
            let state = this.status || {};
            if (state.hasOwnProperty('operation')) {
                this.errorCode = null;
                this.isActive = state.operation.dehumidifierOperationMode === 'POWER_ON';
                this.op_mode = (state.operation.dehumidifierOperationMode === 'POWER_OFF') ? 'POWER_OFF' : state.dehumidifierJobMode.currentJobMode;
                this.humidity = state.humidity.currentHumidity;
            }
            if (state.hasOwnProperty('code')) {
                this.errorHandle(state.code);
            }
            this.isLoading = false;
        },
        errorHandle(errorCode) {
            this.errorCode = errorCode;
            switch (errorCode) {
                case "1222":
                    this.isActive = false;
                    this.op_mode = 'DISCONNECTED'
                    break;
                case "1223": //DeviceNotRespondingException
                case "2210": //Retry Request
                case "2202": //Not supported product
                    break;
                default:
                    this.$toastr.s(this.$t(`error.${errorCode}`))
                    break;
            }
        },
        turnOnOff() {
            if (this.op_mode === 'DISCONNECTED') return false;
            let locale = navigator.language || navigator.userLanguage;
            for (let item of $simple_obj) {
                if (this.onCtrl.power === null && item.deviceId === this.device_id) {
                    if (this.isActive) {
                        item.turnOff();
                        this.onCtrl.power = 'POWER_OFF';
                        if (locale.indexOf('CA') < 0) {
                            this.$analytics.logEvent("device_control", {
                                device_id: this.device_id,
                                control_value: 'DEHUMIDIFIER.POWER.OFF'
                            });
                        }
                    } else {
                        item.turnOn();
                        this.onCtrl.power = 'POWER_ON';
                        if (locale.indexOf('CA') < 0) {
                            this.$analytics.logEvent("device_control", {
                                device_id: this.device_id,
                                control_value: 'DEHUMIDIFIER.POWER.ON'
                            });
                        }
                    }
                    this.isActive = !this.isActive;
                    this.getStatus(false);
                }
            }
        },
    },
    computed: {
        name: function() {
            try {
                return this.device_alias
            } catch (e) {
                return this.$i18n.t('property.DEVICE_AIR_PURIFIER.label.name');
            }
        },
        subscription_event: function() {
            return this.$store.state.subscription_event;
        }
    },
    watch: {
        status: function() {
            this.op_status()
        },
        subscription_event: function(newVal) {
            if (newVal.event.deviceId === this.device_id) {
                this.status = newVal.event.report;
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.polling);
    }
}